<template>
  <div class="page-column">
    <Header/>
    <TrackPaylerDetail />
    <Footer/>
  </div>
</template>

<script>
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
import TrackPaylerDetail from  '@comm/components/match/trackfield/components/TrackPaylerDetail.vue'

export default {
  components: {
    Header,
    TrackPaylerDetail,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
    this.$bus.$emit('handleMenu',0,2)
  },
  methods: {
  },
  
}
</script>
<style lang="scss" scoped>
.page-column {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/district/views/project/components/TrackFieldPlayer.vue